'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import * as CustomPropTypes from '../../../constants/PropTypes';
import UITag from 'UIComponents/tag/UITag';
import * as FilterKey from '../../../constants/search/FilterKey';
import FilterTagText from './FilterTagText';

const FilterTag = ({
  activeCategory,
  filterKey,
  onCloseClick,
  value
}) => {
  return /*#__PURE__*/_jsx(UITag, {
    className: "m-left-0 m-right-2 m-y-1",
    closeable: true,
    inline: true,
    onCloseClick: onCloseClick,
    children: /*#__PURE__*/_jsx(FilterTagText, {
      activeCategory: activeCategory,
      filterKey: filterKey,
      value: value
    })
  });
};

FilterTag.propTypes = {
  activeCategory: CustomPropTypes.category,
  filterKey: PropTypes.oneOf(Object.values(FilterKey)).isRequired,
  onCloseClick: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]).isRequired
};
export default FilterTag;